export const NO_IMAGE_URL = "bossard_no_image.svg"; // Innovadis custom
export const NO_PRODUCT_IMAGE_URL = "bossard_no_productimage.jpg"; // Innovadis custom
